async function updateCartItemQuantityLimit(line, quantity) {
    try {
        const response = await fetch(`/cart/change.js`, { method: "POST", headers: { "Content-Type": "application/x-www-form-urlencoded" }, body: `line=${line}&quantity=${quantity}` });
        const data = await response.json();
        const quantityInput = document.querySelector('input[name="quantity"]');
        if (quantityInput) {
            quantityInput.value = 1;
        }
    } catch (error) {
        console.error("Error updating cart item quantity:", error);
    }
}
async function applyStylesForLimitedProducts() {
    const cartData = window.cartData;
    const style = document.createElement("style");
    style.type = "text/css";
    let cssRules = "";
    cartData.items.forEach((item) => {
        const productIdStr = item.product_id.toString();
        const limitRule = window.limit_rules.product_limit.find(product => product.id === productIdStr);
        if (limitRule) {
            const limit = limitRule.limit;
            cssRules += `[data-variant-id="${item.variant_id}"] [data-value="${limit}"] .js-qty__adjust--plus {\n                opacity: .4;\n                transition: .2s all;\n                pointer-events: none;\n            }\n`;
            cssRules += `[data-variant-id="${item.variant_id}"] [data-value="${limit}"] input {\n                opacity: .4;\n                transition: .2s all;\n                pointer-events: none;\n            }\n`;
        }
    });
    if (style.styleSheet) {
        style.styleSheet.cssText = cssRules;
    } else {
        style.appendChild(document.createTextNode(cssRules));
    }
    document.head.appendChild(style);
}
async function hideAddToCartButtonIfLimitReached() {
    if (!ShopifyAnalytics.meta.product?.id && !document.querySelector('product-variant-form')?.dataset?.productid) {
        return;
    }
    const productPageId = ShopifyAnalytics?.meta?.product?.id?.toString() ? ShopifyAnalytics.meta.product.id.toString() : document.querySelector('product-variant-form').dataset.productid;
    const limitRule = window.limit_rules.product_limit.find(product => product.id === productPageId);
    if (limitRule) {
        try {
            const limit = limitRule.limit;
            const cartData = window.cartData;
            let productQuantityInCart = 0;
            cartData.items.forEach((item) => {
                if (item.product_id.toString() === productPageId) {
                    productQuantityInCart += item.quantity;
                }
            });
            const addToCartBtn = document.querySelector(".add-to-cart-btn");
            if (addToCartBtn) {
                addToCartBtn.style.opacity = productQuantityInCart >= limit ? "0.8" : "1";
                addToCartBtn.style.pointerEvents = productQuantityInCart >= limit ? "none" : "all";
            }
        } catch (error) {
            console.error("Error in hideAddToCartButtonIfLimitReached function:", error);
        }
    }
}
async function checkAndUpdateCartForLimitedProducts() {
    try {
        const cartData = window.cartData;
        let productQuantities = {};
        cartData.items.forEach((item) => {
            const productIdStr = item.product_id.toString();
            const limitRule = window.limit_rules.product_limit.find(product => product.id === productIdStr);
            if (limitRule) {
                const limit = limitRule.limit;
                productQuantities[item.product_id] = { totalQuantity: (productQuantities[item.product_id]?.totalQuantity || 0) + item.quantity, limit: limit };
            }
        });
        for (let i = 0; i < cartData.items.length; i++) {
            const item = cartData.items[i];
            if (item.product_id in productQuantities) {
                const { totalQuantity: totalQuantity, limit: limit } = productQuantities[item.product_id];
                if (totalQuantity > limit) {
                    const excessQuantity = totalQuantity - limit;
                    const newQuantity = Math.max(item.quantity - excessQuantity, 0);
                    await updateCartItemQuantityLimit(i + 1, newQuantity > 0 ? newQuantity : 1);
                }
            }
        }
    } catch (error) {
        console.error("Error in checkAndUpdateCartForLimitedProducts function:", error);
    }
}

async function refreshLimits() {
    await checkAndUpdateCartForLimitedProducts();
    await hideAddToCartButtonIfLimitReached();
    await applyStylesForLimitedProducts();
}

document.addEventListener("DOMContentLoaded", () => {
    refreshLimits();

    document.addEventListener("click", (e) => {
        const target = e.target;
        if (target.closest('.add-to-cart-btn') || target.closest('.js-qty__adjust') || target.closest('.cart__item-remove')) {
            setTimeout(refreshLimits, 300);
        }
    });

    document.addEventListener("cart:updated", refreshLimits);
    document.addEventListener("cart:ready", refreshLimits);
});
